<template>
  <header v-if="showHeader" class="header-mobile bg-white">
    <nav class="header-mobile__nav max-w-[1650px] mx-auto">
      <div class="w-full mx-auto">
        <div class="nav__container header-mobile__content">
          <!-- Website Logo -->
          <router-link to="/" class="flex items-center router-link-active header-mobile__logo-link" aria-label="Geeq Home">
            <img src="/images/geeq-logo.png" alt="Geeq logo" class="header-mobile__logo">
          </router-link>

          <div class="header-mobile__search-wrap">
            <search-form />
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import SearchForm from '@/components/mobile/SearchForm.vue';

export default {
  name: 'HeaderMobileComponent',
  components: { SearchForm },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    //
  }),
  methods: {
    //
  }
}
</script>

<style scoped>
.header-mobile {
  width: 100%;
  min-height: 96px;
  border-bottom: 1px solid #f2f2f2;
}

.header-mobile__nav {
  padding: 20px 16px;
}

.header-mobile__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.header-mobile__logo-link {
  width: 100%;
  display: flex;
  justify-content: center;
}

.header-mobile__logo {
  width: 100%;
  max-width: 220px;
  height: auto;
  object-fit: contain;
}

.header-mobile__search-wrap {
  width: 100%;
  max-width: 640px;
}

.header-mobile__search-wrap :deep(.search-form) {
  margin-top: 0 !important;
}

.header-mobile__search-wrap :deep(.search-input) {
  border: 1px solid #e4e7ec;
}

@media (max-width: 480px) {
  .header-mobile {
    min-height: 84px;
  }

  .header-mobile__nav {
    padding: 14px 12px;
  }

  .header-mobile__logo {
    max-width: 180px;
  }
}

@media (min-width: 768px) {
  .header-mobile {
    display: none;
  }
}
</style>
